import {Item} from "../../models/Item";
import {AbstractMainPlugin} from "../AbstractMainPlugin";
import {ConcreteLayerService} from "../../services/concreteLayer/concrete-layer.service";
import {appInjector} from "../appInjector";


export class ConcreteLayerPlugin extends AbstractMainPlugin{

  protected concreteLayerService: ConcreteLayerService;

  constructor(item:Item) {
    super(item);
    this.concreteLayerService = appInjector.get(ConcreteLayerService);
    this.concreteLayerService.registerConcreteHierarchyItem(item);
  }

}
